/* eslint-disable no-unused-vars */
export default [
    {
        "icon": "github",
        "url": "https://github.com/sfyll"
    },
    {
        "icon": "twitter",
        "url": "https://twitter.com/sfyll"
    },
    {
        "icon": "maildotru",
        "url": "mailto:me@sfyl.xyz"
    }

]